import { createPortal } from 'react-dom';

export function PanelNavSlot({ children }) {
  const el = document.querySelector(
    '.terra-panel .top-nav .right-side .custom-slot'
  );

  if (el) {
    return createPortal(children, el);
  }
  return null;
}
